import { useRouter } from 'next/router';

import { useRentalManagerUserPropertyEditWebApiHandler_propertyType } from '@zg-rentals/ts-rental-manager-api-beta-client-react-query';

import { useGetListingDetails } from '../../../hooks/queries/properties';
import { useFieldSave } from '../../../hooks/useFieldSave';
import { usePropertyEditMutation } from '../../../hooks/usePropertyEditMutation';
import propertyUtils from '../../../utils/propertyUtils';

import PropertyConstants from '../../../constants/PropertyConstants';

import EditPropertyType from '../../EditPropertyType';

import type { CorrectPropertyTypes } from '../../EditPropertyType';

const { PROPERTY_CODE_TO_ENUM, PROPERTY_CODES_BY_TYPE, PROPERTY_TYPES_BY_CODE, PROPERTY_TYPES } = PropertyConstants;

const PropertyTypeFormField = () => {
  const router = useRouter();
  const listingAlias = router.query.listingAlias as string;

  const { data: listingDetails } = useGetListingDetails(listingAlias);

  const propertyType = listingDetails?.propertyType?.code
    ? PROPERTY_TYPES_BY_CODE[listingDetails?.propertyType?.code]
    : PROPERTY_TYPES.HOUSE;

  const isRoomForRent = propertyUtils.isRoomForRent({ listing: listingDetails });

  const updateMutation = usePropertyEditMutation({
    mutationHook: useRentalManagerUserPropertyEditWebApiHandler_propertyType,
  });

  const propertyTypeField = useFieldSave({
    fieldName: 'propertyType',
    initialValue: propertyType as CorrectPropertyTypes,
    mutation: updateMutation,
    buildMutationVariables: (value: CorrectPropertyTypes) => {
      const propertyTypeEnum = PROPERTY_CODE_TO_ENUM[PROPERTY_CODES_BY_TYPE[value]];
      return {
        getParams: {
          listingAlias,
          propertyType: propertyTypeEnum,
        },
      };
    },
  });

  const handleSelectChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    propertyTypeField.onChange(e.target.value as CorrectPropertyTypes);
  };

  return (
    <div data-testid="PropertyTypeFormField">
      <EditPropertyType
        listingAlias={listingAlias}
        correctPropertyType={propertyTypeField.value}
        onSelectChange={handleSelectChange}
        isRoomForRent={isRoomForRent}
        onConvertComplete={() => {
          // Refresh review page after conversion
          router.reload();
        }}
      />
    </div>
  );
};

export default PropertyTypeFormField;
